import React from "react";
import Service from "./Service";

const ServiceList = ({ services }) => {
    return (
        <ul className="rc-services-list">
            {
                services.map((service, index) => <Service service={service} key={index}/> )
            }
        </ul>
    )
}

export default ServiceList;
